/** Retention hooks — reward tables and cooldown durations. */

export const RETENTION_DAILY_TRACK_LENGTH = 7;

/** @typedef {{ gems?: number, shakes?: number, clears?: number, shrinks?: number }} RetentionGrant */

/** @type {RetentionGrant[]} steps 1–7 */
export const RETENTION_DAILY_REWARDS = [
  { gems: 30 },
  { shakes: 5 },
  { shrinks: 1 },
  { clears: 3 },
  { gems: 50 },
  { shakes: 20 },
  { gems: 50, shakes: 10, clears: 2, shrinks: 1 },
];

var PRODUCTION_WHEEL_FREE_SPIN_COOLDOWN_MS = 5 * 60 * 1000;
var PRODUCTION_WHEEL_AD_COOLDOWN_MS = 5 * 60 * 1000;
var DEV_WHEEL_FREE_SPIN_COOLDOWN_MS = 10 * 1000;
var DEV_WHEEL_AD_COOLDOWN_MS = 10 * 1000;

/**
 * @param {{ DEV?: boolean } | null | undefined} [env]
 * @returns {{ freeSpinMs: number, adSpinMs: number }}
 */
export function resolveRetentionWheelCooldowns(env) {
  var dev = !!(env && env.DEV);
  return {
    freeSpinMs: dev ? DEV_WHEEL_FREE_SPIN_COOLDOWN_MS : PRODUCTION_WHEEL_FREE_SPIN_COOLDOWN_MS,
    adSpinMs: dev ? DEV_WHEEL_AD_COOLDOWN_MS : PRODUCTION_WHEEL_AD_COOLDOWN_MS,
  };
}

var wheelCooldowns = resolveRetentionWheelCooldowns(
  typeof import.meta !== "undefined" ? import.meta.env : undefined
);

var PRODUCTION_GEMS_AD_COOLDOWN_MS = 5 * 60 * 1000;
var DEV_GEMS_AD_COOLDOWN_MS = 60 * 1000;

/**
 * @param {{ DEV?: boolean } | null | undefined} [env]
 * @returns {number}
 */
export function resolveRetentionGemsAdCooldownMs(env) {
  return env && env.DEV ? DEV_GEMS_AD_COOLDOWN_MS : PRODUCTION_GEMS_AD_COOLDOWN_MS;
}

export const RETENTION_WHEEL_FREE_SPIN_COOLDOWN_MS = wheelCooldowns.freeSpinMs;
export const RETENTION_WHEEL_AD_COOLDOWN_MS = wheelCooldowns.adSpinMs;
export const RETENTION_GEMS_AD_COOLDOWN_MS = resolveRetentionGemsAdCooldownMs(
  typeof import.meta !== "undefined" ? import.meta.env : undefined
);
export const RETENTION_GEMS_AD_REWARD = 20;

/**
 * Visual wheel segments (clockwise). `weight` drives random selection.
 * @type {Array<{ id: string, label: string, grant: RetentionGrant, weight: number }>}
 */
export const RETENTION_WHEEL_SEGMENTS = [
  { id: "gems10a", label: "+10", grant: { gems: 10 }, weight: 97 / 7 / 100 },
  { id: "gems150", label: "+150", grant: { gems: 150 }, weight: 0.03 },
  { id: "gems10b", label: "+10", grant: { gems: 10 }, weight: 97 / 7 / 100 },
  { id: "shakes3", label: "+3", grant: { shakes: 3 }, weight: 97 / 7 / 100 },
  { id: "gems20a", label: "+20", grant: { gems: 20 }, weight: 97 / 7 / 100 },
  { id: "shrink1", label: "+1", grant: { shrinks: 1 }, weight: 97 / 7 / 100 },
  { id: "gems20b", label: "+20", grant: { gems: 20 }, weight: 97 / 7 / 100 },
  { id: "clear1", label: "+1", grant: { clears: 1 }, weight: 97 / 7 / 100 },
];

/** Desaturated rainbow; pink sits between red and purple on the hue arc (clockwise from segment 0). */
export const RETENTION_WHEEL_SEGMENT_COLORS = [
  "#d86666", /* red */
  "#d084a8", /* pink */
  "#9a7ec4", /* purple */
  "#8f88c8", /* violet */
  "#6a9ecf", /* blue */
  "#6eb88a", /* green */
  "#d4bc6a", /* yellow */
  "#d9925c", /* orange */
];
